import React from 'react';
import cx from 'classnames';
import {formsStore as store} from '../../stores/Form';
import {formsStore as legacyStore} from '../../_legacy/Form/stores/FormsStore';

import {Screen} from './components/Screen';
import {observer} from 'mobx-react';
import {SidePanelButtons} from './components/SidePanelForms/Common/components/SidePanelButtons';
import './styles/theme/theme.scss';
import styles from './styles/screen.module.scss';

import {QueryClientProvider} from 'react-query';
import {queryClient} from './queryClientConfiq';
import {FormDesignPanel} from '../FormDesign/components/FormDesignPanel';
import {setDesignPanelOpen} from './actions/form';
import {returnFocus} from '../../_shared/GWTBridge/invoke/genPage';

export const ScreenWrapperContent = observer(() => {
    const {sidePanelSubforms, designPanelOpened} = store;

    const closeDesignPanel = () => {
        setDesignPanelOpen(false);
        returnFocus();
    };
    return (
        <QueryClientProvider client={queryClient}>
            <div className={cx('react-screen-wrapper', styles.reactScreenWrapper)}>
                <div className={cx('react-screen-wrapper-inner', styles.screenWrapper)}>
                    <Screen />
                </div>
                <div
                    key={
                        legacyStore.currentSession || store.currentScreen?.getActiveForm()?.session
                    }
                >
                    {sidePanelSubforms &&
                        !store.currentScreen?.getActiveForm()?.searchModeLevel && (
                            <SidePanelButtons sidePanelSubforms={sidePanelSubforms} />
                        )}
                </div>
                {legacyStore.currentSession && designPanelOpened && (
                    <FormDesignPanel onClose={closeDesignPanel} />
                )}
            </div>
        </QueryClientProvider>
    );
});
